/* eslint-disable @next/next/no-img-element */
import {Button, ButtonProps} from 'antd';
import useCommon from '@utils/hooks/common';
import styles from './styles';
import classNames from 'classnames';

interface GradientButtonProps extends ButtonProps {
  className?: string;
  isBlue?: boolean;
  isOutlined?: boolean;
}

const GradientButton = (props: GradientButtonProps) => {
  const {classes, t} = useCommon({
    withTranslation: null,
    withStyles: styles,
  });

  const {className, children, isBlue = true, isOutlined = false, ...rest} = props;

  return (
    <Button
      className={classNames(
        classes.blueGradientButton,
        {
          [classes.greyGradientButton]: !isBlue || rest.disabled,
          [classes.outlinedButton]: isOutlined || rest.disabled,
        },
        className
      )}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default GradientButton;
